import { object, ref, string } from "yup";
import { FormikProps, FormikActions } from "formik";

import { reduceFieldSettings, TItem } from "../../../utils/reduceFieldSettings";

const list: Array<TItem> = [
  {
    name: "email",
    type: "email",
    initValue: "",
    placeholder: "Email",
    validationRule: string()
      .email("Not valid email.")
      .required("Email is required."),
  },
  {
    name: "password",
    type: "password",
    initValue: "",
    placeholder: "Password",
    validationRule: string()
      .min(6)
      .max(30)
      .required("Password is required"),
  },
  {
    name: "rePassword",
    type: "password",
    initValue: "",
    placeholder: "Re-type password",
    validationRule: string()
      .oneOf([ref("password"), null], "Passwords must match!")
      .required("Re-Type password is required"),
  },
];

const { initialValues, fields, validationRuleObject } = reduceFieldSettings(list);

const validationSchema = object().shape(validationRuleObject);

export type ValueTypes = typeof initialValues;

export type FormTypes = FormikProps<ValueTypes>;

export type FormActionTypes = FormikActions<ValueTypes>;

export {
  fields,
  initialValues,
  validationSchema,
};
